import { render, staticRenderFns } from "./providerCarousel.vue?vue&type=template&id=4dcab8e8"
import script from "./providerCarousel.vue?vue&type=script&lang=js"
export * from "./providerCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports